import React, { useRef, useState } from "react"
import { Form, Button, Card, Alert, Container } from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { Link, useHistory } from "react-router-dom"
import leadtubLogoWhite from '../assets/logo/leadtubLogoBlack.png'

export default function Settings() {
    const emailRef = useRef()
    const passwordRef = useRef()
    const passwordConfirmRef = useRef()
    const { currentUser, handleUpdatePassword } = useAuth()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const history = useHistory()


    function handleSubmit(e) {
        e.preventDefault()
        if (passwordRef.current.value !== passwordConfirmRef.current.value) {
            return setError("Lösenorden matchar inte")
        }

        const promises = []
        setLoading(true)
        setError("")

        if (emailRef.current.value !== currentUser.email) {
            promises.push(handleUpdatePassword(emailRef.current.value))
        }
        if (passwordRef.current.value) {
            promises.push(handleUpdatePassword(passwordRef.current.value))
        }

        Promise.all(promises)
            .then(() => {
                history.push("/")
            })
            .catch(() => {
                setError("Misslyckat försök")
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <>
            <Card className={'card'}>
                <Card.Body>
                    <img style={{
                        display: 'block',
                        marginLeft: "auto",
                        marginRight: "auto",

                        paddingTop: 30,
                        paddingBottom: 45
                    }} alt="Logo" src={leadtubLogoWhite} />


                    <Container>
                        <span style={{ fontSize: 25 }}
                        >Fyll i din e-postadress som är kopplat till ditt Leadtub konto nedan.

                            Du kommer sedan få ett mejl med instruktioner om hur du återställer ditt lösenord."
                        </span>
                    </Container>

                    <h2 className="text-center mb-4">Uppdatera profiluppgifter</h2>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group id="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                disabled={true}
                                type="email"
                                ref={emailRef}
                                defaultValue={currentUser.email}
                            />
                        </Form.Group>
                        <Form.Group id="password">
                            <Form.Label>Nytt lösenord</Form.Label>
                            <Form.Control
                                type="password"
                                ref={passwordRef}
                                placeholder="*****"
                            />
                        </Form.Group>
                        <Form.Group id="password-confirm">
                            <Form.Label>Upprepa lösenord</Form.Label>
                            <Form.Control
                                type="password"
                                ref={passwordConfirmRef}
                                placeholder="*****"
                            />
                        </Form.Group>
                        <div className="w-100 text-center mt-2">
                            <Button disabled={loading} className="" type="submit">
                                Uppdatera
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
                <div className="w-100 text-center mt-2">
                    <Link to="/">Avbryt</Link>
                </div>
            </Card>

        </>
    )
}
